var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "statistik" }, [
    _c(
      "div",
      { staticClass: "main-wrapper" },
      [
        _c("layout-header"),
        _vm._v(" "),
        _c("layout-sidebar"),
        _vm._v(" "),
        _c("div", { staticClass: "page-wrapper" }, [
          _c("div", { staticClass: "content container-fluid" }, [
            _c("div", { staticClass: "page-header" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col" }, [
                  _c("h3", { staticClass: "page-title" }, [
                    _vm._v("Post Statistik")
                  ]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "breadcrumb" }, [
                    _c(
                      "li",
                      { staticClass: "breadcrumb-item" },
                      [
                        _c("router-link", { attrs: { to: "/index" } }, [
                          _vm._v("Dashboard")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("li", { staticClass: "breadcrumb-item active" }, [
                      _vm._v("Post Statistik")
                    ])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-12" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-12" }, [
                    _c("div", { staticClass: "of-card-body-a" }, [
                      _vm.caption
                        ? _c("div", { staticClass: "of-card-body-cap" }, [
                            _c("div", { staticClass: "of-card-body-cap-1" }, [
                              _c(
                                "p",
                                {
                                  staticClass: "of-card-body-cap-2",
                                  attrs: { title: _vm.caption }
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.caption) +
                                      "\n                      "
                                  )
                                ]
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "of-card-body-img" },
                        [
                          _vm.assetsUrl.length > 0
                            ? [
                                _vm.assetsUrl[0].includes(".jpg") ||
                                _vm.assetsUrl[0].includes(".jpeg")
                                  ? _c("img", {
                                      staticClass: "of-card-body-img-p",
                                      attrs: {
                                        src: _vm.assetsUrl[0],
                                        alt: _vm.caption
                                      }
                                    })
                                  : _vm.assetsUrl[0].includes(".mp4")
                                  ? _c(
                                      "video",
                                      {
                                        staticStyle: {
                                          width: "100%",
                                          height: "100%",
                                          overflow: "hidden"
                                        },
                                        attrs: { controls: "" }
                                      },
                                      [
                                        _c("source", {
                                          attrs: {
                                            src: _vm.assetsUrl[0],
                                            type: "video/mp4"
                                          }
                                        })
                                      ]
                                    )
                                  : _c("img", {
                                      staticClass: "of-card-body-img-p",
                                      attrs: {
                                        src: require("@/assets/placeholder.jpg"),
                                        alt: ""
                                      }
                                    })
                              ]
                            : [
                                _c("img", {
                                  staticClass: "of-card-body-img-p",
                                  attrs: {
                                    src: require("@/assets/placeholder.jpg"),
                                    alt: ""
                                  }
                                })
                              ]
                        ],
                        2
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "of-card-body-b" })
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "row",
                    staticStyle: { "margin-bottom": "20px" }
                  },
                  [
                    _c("div", { staticClass: "col-md-12" }, [
                      _c("div", { staticClass: "table-responsive" }, [
                        _c(
                          "table",
                          {
                            staticClass: "table table-striped custom-table mb-0"
                          },
                          [
                            _vm._m(0),
                            _vm._v(" "),
                            _c(
                              "tbody",
                              [
                                _vm.loading
                                  ? [
                                      _c("tr", [
                                        _c(
                                          "td",
                                          { attrs: { colspan: "7" } },
                                          [
                                            _c("Skeleton", {
                                              attrs: { count: 1 }
                                            })
                                          ],
                                          1
                                        )
                                      ])
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.rows.length
                                  ? _vm._l(_vm.rows, function(row, index) {
                                      return _c("tr", { key: index }, [
                                        _c(
                                          "td",
                                          {
                                            ref: "account-" + row.id,
                                            refInFor: true,
                                            staticClass: "text-wrap"
                                          },
                                          [
                                            _c("Skeleton", {
                                              attrs: { count: 1 }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("td", { staticClass: "text-wrap" }, [
                                          _vm._v(_vm._s(row.total_like))
                                        ]),
                                        _vm._v(" "),
                                        _c("td", { staticClass: "text-wrap" }, [
                                          _vm._v(_vm._s(row.total_play))
                                        ]),
                                        _vm._v(" "),
                                        _c("td", { staticClass: "text-wrap" }, [
                                          _vm._v(_vm._s(row.total_comment))
                                        ]),
                                        _vm._v(" "),
                                        _c("td", { staticClass: "text-wrap" }, [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(row.total_impressions) +
                                              "\n                          "
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("td", { staticClass: "text-wrap" }, [
                                          _vm._v(_vm._s(row.total_reach))
                                        ]),
                                        _vm._v(" "),
                                        _c("td", { staticClass: "text-wrap" }, [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(row.total_interactions) +
                                              "\n                          "
                                          )
                                        ])
                                      ])
                                    })
                                  : _vm.rows.length < 1 && !_vm.loading
                                  ? [_vm._m(1)]
                                  : _vm._e()
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("tfoot", [
                              _c(
                                "tr",
                                [
                                  _vm._m(2),
                                  _vm._v(" "),
                                  _vm._l(_vm.summary, function(rowSum, idx) {
                                    return _c("td", { key: idx }, [
                                      _vm._v(
                                        "\n                          " +
                                          _vm._s(rowSum.total) +
                                          "\n                        "
                                      )
                                    ])
                                  })
                                ],
                                2
                              )
                            ])
                          ]
                        )
                      ])
                    ])
                  ]
                )
              ])
            ])
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Accounts")]),
        _vm._v(" "),
        _c("th", [_vm._v("Total Like")]),
        _vm._v(" "),
        _c("th", [_vm._v("Total Play")]),
        _vm._v(" "),
        _c("th", [_vm._v("Total Comments")]),
        _vm._v(" "),
        _c("th", [_vm._v("Total Impressions")]),
        _vm._v(" "),
        _c("th", [_vm._v("Total Reach")]),
        _vm._v(" "),
        _c("th", [_vm._v("Total Interactions")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "text-center", attrs: { colspan: "7" } }, [
        _vm._v("-empty-")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("b", [_vm._v("Summary")])])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-21051ff6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21051ff6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/instagram/instagramScheduleOfficial/statistik.vue
// module id = null
// module chunks = 